const toDate = (dateLiteral) =>
  new Date(
    Date.parse(dateLiteral) + new Date(dateLiteral).getTimezoneOffset() * 60 * 1000,
  );

const toLocaleDate = (dateLiteral) =>
  toDate(dateLiteral).toLocaleDateString(undefined, {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  const toLocaleDateShort = (dateLiteral) =>
  toDate(dateLiteral).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });

export { toLocaleDate, toLocaleDateShort };
